<template>
  <div class="table-responsive placeholder-glow">
    <div class="col-12 text-center" v-if="ativa_placeholder">
      Carregando dados, aguarde ... <spinner></spinner>
    </div>
    <div :class="['col-12', class_placeholder]">
      <DataTable :columns="columns" :options="options" :data="dadosData" :ajax="dadosAjax" :data-order='ordem_tabela'
        :class="['display', 'table', 'table-striped', 'table-sm', 'table-responsive-sm', 'mb-1', 'table-hover', 'table-sm', 'shadow']"
        width="100%">
        <thead>
          <tr>
            <th></th>
          </tr>
        </thead>
        <template #column-image="props">
          <template v-if="showPathImage">
            <img :src="showPathImage + props.cellData" style="height: 80px !important;"
              class="img-fluid img-thumbnail rounded self-align-center" alt="">
          </template>
        </template>
        <template #column-acoes="props">
          <div v-if="btnEdit || btnDelete || btnStatus || btnPersonalizado">
            <template v-if="btnEdit">
              <button type="button" class="btn btn-sm btn-primary mx-2"
                :data-bs-toggle="[(modal_target_edit ? 'modal' : '')]" :data-bs-target="modal_target_edit"
                @click="edit(props)"><i class="bi bi-pencil-square"></i></button>
            </template>
            <template v-if="btnDelete">
              <button type="button" class="btn btn-sm btn-danger"
                :data-bs-toggle="[(modal_target_delete ? 'modal' : '')]" :data-bs-target="modal_target_delete"
                @click="del(props)"><i class="bi bi-trash3-fill"></i></button>
            </template>
            <template v-if="btnPersonalizado">
              <template v-if="props.cellData > 0 && auth.type_access < 4">
                <button type="button" :class="['btn btn-sm', 'btn-' + btnPersonalizado.btn]"
                  @click="personalizado(props)">{{ btnPersonalizado.textoBtn }} <span class="badge text-bg-light">{{
                    props.cellData }}</span></button>
              </template>
              <template v-else>
                {{ props.cellData }}
              </template>
            </template>
            <div v-if="btnStatus" class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" @click="edit_status(props)"
                :checked="verificaStatus(props.cellData)">
              <label class="form-check-label btn-secondary" for="flexSwitchCheckDefault"></label>
              {{ props.cellData }}
            </div>
            <template v-if="btnLinkRota">
              <button @click="to_route(btnLinkRota.rota + props.rowData.id)" class="btn btn-sm btn-primary mx-2">
                <i class="bi bi-camera-reels"></i> {{ btnLinkRota.texto }}
              </button>
            </template>
          </div>
          <div v-else>
            {{ props.cellData }}
          </div>
        </template>
        <tfoot>
          <tr>
            <th v-for="(col, i) in columns" :key="i">{{ col.title }}</th>
          </tr>
        </tfoot>
      </DataTable>
    </div>
  </div>
</template>

<script>
import jszip from 'jszip';
import pdfmake from 'pdfmake';
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
import 'datatables.net-buttons-bs5';
import 'datatables.net-buttons/js/buttons.colVis.mjs';
import 'datatables.net-buttons/js/buttons.html5.mjs';
import 'datatables.net-buttons/js/buttons.print.mjs';
import 'datatables.net-colreorder-bs5';
import 'datatables.net-fixedcolumns-bs5';
import 'datatables.net-fixedheader-bs5';
import 'datatables.net-responsive-bs5';
import 'datatables.net-select-bs5';
import Spinner from './Spinner.vue';
import { to_route } from '@/assets/js/requests'
import { AuthStore } from '@/stores/Auth';

export default {
  name: 'TabelaDatatable',
  data() {
    return {
      auth: AuthStore(),
      options: {
        layout: {
          topEnd: 'buttons'
        },
        fixedHeader: true,
        // responsive: true,
        colReorder: true,
        lengthMenu: [
          [10, 25, 50, 100, -1],
          [10, 25, 50, 100, 'Todos']
        ],
        initComplete: function () {
          let api = this.api();

          api.columns().every(function () {
            let column = this;
            let title = column.footer().textContent;
            let th = column.footer();

            // Create input element
            let input = document.createElement('input');
            input.placeholder = title;
            th.replaceChildren(input);

            // Event listener for user input
            input.addEventListener('keyup', () => {
              if (column.search() !== this.value) {
                let idx = [...th.parentNode.children].indexOf(th);

                api
                  .column(idx + ':visible')
                  .search(input.value)
                  .draw();
              }
            });
          });
        },
        // select: true,
        buttons: [{
          extend: 'copy',
          text: '<i class="bi bi-copy"> Copiar</i>',
          exportOptions: {
            modifier: {
              page: 'current'
            }
          }
        }, {
          extend: 'excel',
          text: '<i class="bi bi-file-excel"> Excel</i>',
          exportOptions: {
            modifier: {
              page: 'current'
            }
          }
          // }, {
          //   extend: 'pdf',
          //   text: '<i class="bi bi-filetype-pdf"> PDF</i>',
          //   exportOptions: {
          //     modifier: {
          //       page: 'current'
          //     }
          //   }
        }, {
          extend: 'csv',
          text: '<i class="bi bi-filetype-csv"> CSV</i>',
          exportOptions: {
            modifier: {
              page: 'current'
            }
          }
        }, {
          extend: 'print',
          text: '<i class="bi bi-printer"></i>',
          exportOptions: {
            modifier: {
              page: 'current'
            }
          }
        }],
        oLanguage: {
          "sLengthMenu": "Mostrar _MENU_ registros por página",
          "sZeroRecords": "Nenhum registro encontrado",
          "sInfo": "Mostrando _START_ / _END_ de _TOTAL_ registro(s)",
          "sInfoEmpty": "Mostrando 0 / 0 de 0 registros",
          "sInfoFiltered": "(filtrado de _MAX_ registros)",
          "sSearch": "Pesquisar: ",
          "oPaginate": {
            "sFirst": "Início",
            "sPrevious": "Anterior",
            "sNext": "Próximo",
            "sLast": "Último"
          }
        },
      },
    }
  },
  components: {
    jszip,
    pdfmake,
    DataTable,
    DataTablesCore,
    Spinner,
  },
  props: {
    dadosData: {
      default: [
        {
          // "id": "1",
          // "nome": "William",
          // "acesso": "SEO",
          // "email": "mail@mail.xom",
          // "usuario_indicou": "Teste",
          // "valor_contribuicao": "$112,000",
          // "data_cadastro": "2011/01/25",
          // "telefone": "New York",
          // "status": "ativo"
        }
      ]
    },
    dadosAjax: {
      default: "/data.json"
    },
    columns: {
      default: [
        { data: 'id.', title: 'Cód', width: '5%' },
        { data: 'nome', title: 'Nome', width: '20%' },
        { data: 'email', title: 'Email', width: '20%' },
        { data: 'telefone', title: 'Celular', width: '10%' },
        { data: 'acesso', title: 'Acesso', width: '10%' },
        { data: 'usuario_indicou', title: 'Indicado por:', width: '20%' },
        { data: 'valor_contribuicao', title: 'Valor De Contribuíção', width: '5%' },
        { data: 'data_cadastro', title: 'Data Cadastro', width: '10%' },
        { name: 'acoes', data: 'status', title: 'Status', width: '10%' },
      ]
    },
    btnEdit: {
      default: false,
    },
    btnDelete: {
      default: false,
    },
    btnPersonalizado: {
      default: null,
    },
    btnStatus: {
      default: false,
    },
    showPathImage: {
      default: null,
    },
    btnLinkRota: {
      default: null,
    },
    ativa_placeholder: {
      default: false,
    },
    ordem_tabela: {
      default: '[[0,"asc"]]', //[{ name: 'id', dir: 'desc' }]
    },
    modal_target_edit: String,
    modal_target_delete: String,
  },
  computed: {
    class_placeholder: function () {
      return (this.ativa_placeholder ? 'placeholder' : '')
    }
  },
  methods: {
    edit(propriedade) {
      this.$emit('edit_row', propriedade)
    },
    edit_status(propriedade) {
      this.$emit('edit_status', propriedade)
    },
    del(propriedade) {
      this.$emit('delete_row', propriedade)
    },
    personalizado(propriedade) {
      this.$emit('person_row', propriedade)
    },
    verificaStatus(valor) {
      if (valor == 'Ativo') {
        return true
      } else {
        return false
      }
    },
    to_route(rota) {
      this.$router.push(rota)
    },
  },
  created() {
    DataTablesCore.Buttons.jszip(jszip);
    DataTablesCore.Buttons.pdfMake(pdfmake);
    DataTable.use(DataTablesCore);
  },
}
</script>

<style>
@import url('bootstrap');
@import url('datatables.net-bs5');
@import url('datatables.net-buttons-bs5');
@import url('datatables.net-colreorder-bs5');
@import url('datatables.net-fixedcolumns-bs5');
@import url('datatables.net-fixedheader-bs5');
@import url('datatables.net-responsive-bs5');
@import url('datatables.net-select-bs5');

.datatable {
  padding-bottom: 50px !important;
}

.custom-switch .custom-control-label::after {
  background-color: red;
}

.custom-switch .custom-control-label::before {
  border-color: red;
}
</style>